import { Terminal, Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { openAlertSheet } from "./StickyAlertBar";

export const NAV_LINKS = [
  { label: "Approval tracker", href: "/peptide-horizon" },
  { label: "Peptides", href: "/compounds" },
  { label: "GLP-1s", href: "/glp-1-cost" },
  { label: "News", href: "/policy" },
  { label: "Email alerts", href: "/alerts" },
];

/** The single site header, rendered once by AppRoutes for every route. */
export default function SiteHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setIsOpen(false); }, [location.pathname]);
  useEffect(() => {
    const resize = () => { if (window.innerWidth >= 1024) setIsOpen(false); };
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);
  const alerts = () => { setIsOpen(false); openAlertSheet(); };
  return <>
    <nav aria-label="Main navigation" className="fixed top-0 inset-x-0 z-[100] bg-background border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 flex h-14 items-center justify-between">
        <Link to="/" className="flex items-center gap-2 min-h-11" onClick={() => setIsOpen(false)}>
          <Terminal className="h-5 w-5 text-primary" aria-hidden="true" />
          <span className="text-lg font-semibold">PeptideX<span className="text-primary">.ai</span></span>
        </Link>
        <div className="hidden lg:flex items-center gap-5">
          {NAV_LINKS.map(link => <Link key={link.href} to={link.href} className="inline-flex items-center min-h-11 text-sm text-foreground hover:text-primary">{link.label}</Link>)}
          <Button onClick={alerts} className="min-h-11">Get email updates</Button>
        </div>
        <Button variant="ghost" size="icon" className="lg:hidden min-h-11 min-w-11" onClick={() => setIsOpen(value => !value)} aria-label={isOpen ? "Close menu" : "Open menu"} aria-expanded={isOpen} aria-controls="mobile-navigation">
          {isOpen ? <X /> : <Menu />}
        </Button>
      </div>
    </nav>
    {isOpen && <>
      <div className="fixed inset-0 z-[90] bg-background/80 lg:hidden" onClick={() => setIsOpen(false)} />
      <div id="mobile-navigation" className="fixed top-14 inset-x-0 z-[95] bg-background border-b border-border lg:hidden max-h-[calc(100dvh-56px)] overflow-y-auto">
        <div className="container mx-auto px-4 py-4 flex flex-col">
          {NAV_LINKS.map(link => <Link key={link.href} to={link.href} onClick={() => setIsOpen(false)} className="min-h-12 flex items-center text-base text-foreground border-b border-border">{link.label}</Link>)}
          <Button onClick={alerts} className="min-h-12 mt-3">Get email updates</Button>
          <p className="text-xs text-muted-foreground mt-3">Educational only · Not medical advice</p>
        </div>
      </div>
    </>}
  </>;
}
